export default function StrengthMeter({ poorPassword, weakPassword, strongPassword, passwordError }: any) {
    return (
        <>

            <p> {passwordError}</p>
        </>

    );
}